<template>
  <div>
    <b-container fluid>
      <h3 class="mt-3 mb-3">Report</h3>

      <div class="search_bar mb-3">
        <b-row>
          <b-col cols="2" class="pr-1">
            <b-form-select
              size="sm"
              v-model="search_criteria.hotel_selected"
              :options="hotel_options"
            />
          </b-col>
          <!-- <b-col cols="4" class="pr-1">
            <b-form-input
              id="input-small"
              size="sm"
              type="text"
              placeholder="SKU / Name"
              v-model="search_criteria.keyword"
            ></b-form-input>
          </b-col> -->
          <b-col cols="12" sm="12" md="2" class="pl-0 pr-1">
            <b-form-input
              id="input-small"
              size="sm"
              type="date"
              v-model="search_criteria.start_at"
            ></b-form-input>
          </b-col>
          <b-col cols="12" sm="12" md="2" class="pl-0 pr-1">
            <b-form-input
              id="input-small"
              size="sm"
              type="date"
              v-model="search_criteria.end_at"
            ></b-form-input>
          </b-col>
          <b-col cols="12" sm="12" md="2" class="pl-0 pr-1">
            <b-form-select
              size="sm"
              v-model="search_criteria.order_status_selected"
              :options="order_status_options"
            />
          </b-col>
          <b-col class="text-left p-0">
            <b-button class="btn-action" size="sm" variant="info" @click="onSearch">
              <font-awesome-icon class="mr-1" icon="search" />Search
            </b-button>

            <b-button class="btn-action" size="sm" variant="info" @click="onExport">
              Export
            </b-button>
          </b-col>
        </b-row>
      </div>

      <b-pagination
        size="sm"
        :total-rows="total_rows"
        v-model="currentPage"
        :per-page="TABLE_LIMIT"
        @change="onPageChange"
        :limit="PAGING_LIMIT"
      ></b-pagination>

      <b-table
        responsive
        small
        outlined
        striped
        hover
        sticky-header="500px"
        :items="items"
      >
        <template v-slot:head(chk_box)="data">
          <b-form-checkbox
            size="sm"
            plain
            id="chkbox_all"
            value="all"
            v-model="check_all_rows"
          ></b-form-checkbox>
        </template>
        <template v-slot:cell(curated_section)="data">
          <b-form-checkbox
            size="sm"
            class="chkbox_row"
            plain
            :id="'chkbox_row_' + data.index"
            v-model="data.item.is_checked"
          ></b-form-checkbox>
        </template>

        <template v-slot:cell(product_image_1)="data">
          <img
            v-if="data.item.product_image_1"
            :src="data.item.product_image_1"
            style="height: 50px"
          />
        </template>

        <template v-slot:cell(action)="data">
          <div class="mb-2">
            <b-form-checkbox
              size="sm"
              class="chkbox_row"
              plain
              :id="'chkbox_row_' + data.index"
              v-model="data.item.is_checked"
              >Curated Section</b-form-checkbox
            >
          </div>
          <b-button
            class="btn-action"
            size="sm"
            variant="info"
            :to="{
              name: 'cms_product_profile',
              params: { product_id: data.item.id },
            }"
            >Edit</b-button
          >

          <b-button
            class="btn-action"
            size="sm"
            variant="danger"
            @click="showModal_confirmDelete(data.item)"
            >Delete</b-button
          >
        </template>
      </b-table>

      <b-pagination
        size="sm"
        :total-rows="total_rows"
        v-model="currentPage"
        :per-page="TABLE_LIMIT"
        @change="onPageChange"
        :limit="PAGING_LIMIT"
      ></b-pagination>

      <b-modal ref="modal_confirmDelete" centered hide-footer hide-header>
        <div class="d-block">
          <b-row class="mb-3">
            <b-col>Are you sure to delete this product?</b-col>
          </b-row>
        </div>
        <div class="text-right">
          <b-btn class="mt-3" variant="outline-danger" @click="hideModal_confirmDelete"
            >Cancel</b-btn
          >
          <b-btn class="mt-3" variant="outline-success" @click="deleteProduct()"
            >Confirm</b-btn
          >
        </div>
      </b-modal>
    </b-container>
  </div>
</template>

<script>
import moment from "moment";
import VueBarcode from "vue-barcode";

const fields = [
  {
    key: "product_image_1",
    label: "Cover Image",
  },
  {
    key: "product_sku",
    label: "SKU",
  },
  {
    key: "flag_2",
    label: "Hotel Code",
  },
  {
    key: "flag_28",
    label: "Outlet",
  },
  {
    key: "product_name_en",
    label: "Name",
  },
  {
    key: "flag_5",
    label: "Local Currency",
  },
  {
    key: "retail_price",
    label: "Original Price",
    class: "center_align",
  },
  {
    key: "sale_price",
    label: "Discounted Price",
    class: "center_align",
  },
  {
    key: "inventory",
    label: "Inventory",
    class: "center_align",
  },
  {
    key: "flag_32",
    label: "Fulfilment Leadtime",
    class: "center_align",
  },
  {
    key: "action",
    label: "Action",
  },
];

export default {
  name: "ProductMaster",
  inject: ["API_HOST", "TABLE_LIMIT", "PAGING_LIMIT"],
  components: {
    barcode: VueBarcode,
  },
  data() {
    return {
      upload_file: [],
      loader: false,
      items: [],
      fields: fields,
      currentPage: 1,
      table_offset: 0,
      total_rows: 0,
      search_criteria: {
        keyword: "",
        start_at: moment()
          .subtract(6, "months")
          .format("YYYY-MM-DD"),
        end_at: moment().format("YYYY-MM-DD"),
        order_status_selected: null,
        hotel_selected : null
      },
      hotel_options: [
        {
          text: "All Hotel",
          value: null,
        },
        {
          text: "ISL",
          value: "ISL",
        },
        {
          text: "KSL",
          value: "KSL",
        },
        {
          text: "KHHK",
          value: "KHHK",
        },
        {
          text: "SLS",
          value: "SLS",
        }
      ],
      check_all_rows: false,
      order_status_options: [
        {
          value: null,
          text: "All Order Status"
        },
        {
          value: "pending",
          text: "Pending"
        },
        {
          value: "completed",
          text: "Completed"
        },
      ],
    };
  },
  async created() {
    await this.getProductMaster();
    this.initialized = true;
  },
  mounted() {
    this.loader = this.$loading.show({
      isFullPage: true,
      canCancel: false,
    });
  },
  watch: {
    // whenever changes, this function will run
    check_all_rows: function (new_val, old_val) {
      if (new_val == "all") {
        // Check all
        for (let i in this.items) {
          this.items[i].is_checked = true;
        }
      } else {
        for (let i in this.items) {
          this.items[i].is_checked = false;
        }
      }
    },
  },
  methods: {
    displayDate(d) {
      if (d) {
        return moment(d).format("YYYY-MM-DD");
      } else {
        return "/";
      }
    },

    async getProductMaster() {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "cms_report_get.php",
        data: {
          offset: this.table_offset,
          limit: this.TABLE_LIMIT,
          search_criteria: this.search_criteria,
          client_id: this.$store.state.user_obj.client_id,
          user_id: this.$store.state.user_obj.user_id,
        },
      });
      this.items = response.data.products;
      this.total_rows = parseInt(response.data.total_rows);
      this.loader.hide();
    },

    async onExport() {

        this.loader = this.$loading.show({
        isFullPage: true,
        canCancel: false
      });

      this.$http({
        baseURL: `${this.API_HOST}`,
        url: "cms_report_get.php",
        method: "POST",
        data: {
          offset: 0,
          limit: 999999,
          mode: 'export',
          search_criteria: this.search_criteria,
          client_id: this.$store.state.user_obj.client_id,
          user_id: this.$store.state.user_obj.user_id,
        },
        responseType: "blob" // important
      }).then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "report.xlsx");
        document.body.appendChild(link);
        link.click();

        this.loader.hide();
      });
    },

    onSearch() {
      this.getProductMaster();
    },

    onPageChange(page_to_change) {
      this.table_offset = (page_to_change - 1) * this.TABLE_LIMIT;
      this.getProductMaster();
    },

    async onUploadFile() {
      this.loader = this.$loading.show({
        isFullPage: true,
        canCancel: false,
      });

      let formData = new FormData();
      formData.append("excel_file", this.upload_file);
      formData.append("client_id", this.$store.state.user_obj.client_id);
      formData.append("user_id", this.$store.state.user_obj.user_id);

      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "product_master_import.php",
        headers: {
          "Content-Type": "multipart/form-data",
        },
        data: formData,
      });

      if (response) {
        this.loader.hide();
        this.$eventHub.$emit("show_modal_message", {
          message_content: "Upload Success",
        });
        this.getProductMaster();
        // window.location.reload();
      }
    },

    showModal_confirmDelete(item) {
      this.$refs.modal_confirmDelete.item = item;
      this.$refs.modal_confirmDelete.show();
    },

    hideModal_confirmDelete() {
      this.$refs.modal_confirmDelete.hide();
    },

    async deleteProduct() {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "product_delete.php",
        data: {
          product_id: this.$refs.modal_confirmDelete.item.id,
          client_id: this.$store.state.user_obj.client_id,
          user_id: this.$store.state.user_obj.user_id,
        },
      });

      this.getProductMaster();
      this.hideModal_confirmDelete();
    },
  },
};
</script>

<style>
th,
td {
  white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/components/CmsReport.vue